import { render, staticRenderFns } from "./EditPersonAssetDialog.vue?vue&type=template&id=5f1c8358&scoped=true&"
import script from "./EditPersonAssetDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonAssetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c8358",
  null
  
)

export default component.exports